// ======================================================================
// File Name       : SuperuserServiceRoleAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { SUPERUSER_SERVICE_ROLE_RECEIVE_LIST } from '../constants/ActionTypes';
import { SUPERUSER_RECEIVE_SETTING_LIST } from '../constants/actionTypes/superUser';
import { commonCallApi } from '../utils/ApiUtils';

function receiveSuperuserServiceRoleList(roleList) {
  return {
    type: SUPERUSER_SERVICE_ROLE_RECEIVE_LIST,
    roleList,
  };
}

export function getSuperuserServiceRoleList(param) {
  return dispatch =>
    commonCallApi({
      path: 'superuserServiceRole/GetList',
      data: param,
      enterpriseId: 1,
    }).then((resdata) => {
      const { roleList } = resdata;
      dispatch(receiveSuperuserServiceRoleList(roleList));
    });
}

export function superuserServiceRoleEdit(param) {
  return (dispatch) => commonCallApi({
    path: 'superuserServiceRole/Edit',
    data: param,
    enterpriseId: 1,
  });
}

export function getSuperuserServiceRoleSettingList(superuserSecernId) {
  const param = {
    superuserSecernId,
  };
  return (dispatch) => commonCallApi({
    path: 'superuserServiceRole/SettingList',
    data: param,
    enterpriseId: 1,
  }).then((resdata) => {
    const { roleList } = resdata;
    dispatch(receiveSuperuserReceiveSettingList(roleList));
  });
}

export function superuserRoleUpdateSetting(param) {
  return (dispatch) => commonCallApi({
    path: 'superuserServiceRole/UpdateSetting',
    data: param,
    enterpriseId: 1,
  });
}

function receiveSuperuserReceiveSettingList(roleList) {
  return {
    type: SUPERUSER_RECEIVE_SETTING_LIST,
    roleList,
  };
}
